document.addEventListener("DOMContentLoaded", function () {
  var desktopCarousel = document.querySelector(
    ".floating-product_cards_carousel",
  );
  var mobileCarousels = document.querySelectorAll(".carousel_mobile");

  var flktyDesktop = null;
  var flktyMobile = [];
  var syncDesktopCardHeights = null;

  function initGlobal() {
    if (!flktyDesktop && desktopCarousel) {
      flktyDesktop = new Flickity(desktopCarousel, {
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        imagesLoaded: true,
        adaptiveHeight: true,
        wrapAround: true,
        setGallerySize: true,
        autoPlay: 5000

      });

      syncDesktopCardHeights = function () {
        if (!desktopCarousel) return;

        const cards = Array.from(desktopCarousel.querySelectorAll('.product-card'));
        if (!cards.length) return;

        cards.forEach((card) => {
          card.style.minHeight = '';
        });

        const maxCardHeight = Math.max(...cards.map((card) => card.offsetHeight));
        if (maxCardHeight > 0) {
          cards.forEach((card) => {
            card.style.minHeight = `${maxCardHeight}px`;
          });
        }
      };

      const syncDesktopViewportHeight = function () {
        if (!flktyDesktop || !flktyDesktop.viewport) return;

        if (typeof syncDesktopCardHeights === 'function') {
          syncDesktopCardHeights();
        }

        const selectedCellElement = flktyDesktop.selectedElement || desktopCarousel.querySelector('.product-card');
        if (!selectedCellElement) return;

        const cellHeight = selectedCellElement.offsetHeight;
        const cards = Array.from(desktopCarousel.querySelectorAll('.product-card'));
        const maxCardHeight = cards.length ? Math.max(...cards.map((card) => card.offsetHeight)) : cellHeight;
        const viewportHeight = Math.max(cellHeight, maxCardHeight);

        if (viewportHeight > 0) {
          flktyDesktop.viewport.style.height = `${viewportHeight}px`;
        }
      };

      flktyDesktop.on('ready', syncDesktopViewportHeight);
      flktyDesktop.on('select', syncDesktopViewportHeight);
      flktyDesktop.on('settle', syncDesktopViewportHeight);

      const prev = desktopCarousel
        .closest(".floating-product_cards")
        ?.querySelector(".custom-prev");
      const next = desktopCarousel
        .closest(".floating-product_cards")
        ?.querySelector(".custom-next");

      if (prev && next) {
        prev.addEventListener("click", function () {
          flktyDesktop.previous();
        });

        next.addEventListener("click", function () {
          flktyDesktop.next();
        });
      }

      setTimeout(function () {
        flktyDesktop.resize();
        syncDesktopViewportHeight();
      }, 100);

      window.addEventListener('load', function () {
        flktyDesktop.resize();
        syncDesktopViewportHeight();
      });
    }
  }

  function initMobile() {
    mobileCarousels.forEach((carousel, index) => {
      // only initialize if not already
      if (!flktyMobile[index]) {
        flktyMobile[index] = new Flickity(carousel, {
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
          pageDots: true,
          imagesLoaded: true,
          adaptiveHeight: false,
        });

        // setTimeout(function () {
        //   flktyMobile[index].resize();
          
        // }, 100);

        setTimeout(function () {
          // Check if the array wrapper and the specific slider instance exist
          if (flktyMobile && flktyMobile[index] && typeof flktyMobile[index].resize === 'function') {
            flktyMobile[index].resize();
          }
        }, 100);
      }
    });
  }

  function destroyMobile() {
    flktyMobile.forEach((flk) => {
      if (flk) flk.destroy();
    });
    flktyMobile = [];
  }

  function checkScreen() {
    initGlobal();
    if (typeof syncDesktopCardHeights === 'function') {
      syncDesktopCardHeights();
    }
    if (window.innerWidth <= 768) {
      initMobile();
    } else {
      destroyMobile();
    }
  }

  checkScreen();
  window.addEventListener("resize", checkScreen);

  // mobile toggle checkout buttons
  const toggles = document.querySelectorAll(".checkout_accordion_toggle");

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", function () {
      // Run only on mobile
      if (window.innerWidth <= 768) {
        const parent = this.closest(".cart-items_container_right");

        if (parent) {
          parent.classList.toggle("is-open");
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var multicolumnCarousels = document.querySelectorAll(".multicolumn-carousel");
  var multicolumnFlickityInstances = new Map();

  if (!multicolumnCarousels.length || typeof Flickity === "undefined") return;

  function visibleMulticolumnColumns(carousel) {
    if (window.innerWidth >= 768) {
      return Number(carousel.dataset.visibleColumns) || 4;
    }
    return 1;
  }

  function updateMulticolumnCarousel(carousel) {
    var cells = carousel.querySelectorAll(".multicolumn__column");
    var instance = multicolumnFlickityInstances.get(carousel);
    var shouldEnable = cells.length > visibleMulticolumnColumns(carousel);

    if (shouldEnable && !instance) {
      instance = new Flickity(carousel, {
        cellAlign: "left",
        cellSelector: ".multicolumn__column",
        contain: true,
        groupCells: true,
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: false,
        adaptiveHeight: false,
      });
      multicolumnFlickityInstances.set(carousel, instance);
      return;
    }

    if (!shouldEnable && instance) {
      instance.destroy();
      multicolumnFlickityInstances.delete(carousel);
      return;
    }

    if (instance) instance.resize();
  }

  function updateMulticolumnCarousels() {
    multicolumnCarousels.forEach(updateMulticolumnCarousel);
  }

  updateMulticolumnCarousels();
  window.addEventListener("resize", updateMulticolumnCarousels);
});

document.addEventListener("DOMContentLoaded", function () {
  const moneyFormat = window.theme?.settings?.money_with_currency_format || "${{amount}}";

  const formatMoney = (amount) => moneyFormat.replace(/{{\s*amount\s*}}/, Number(amount || 0).toFixed(2));
  const parseMoney = (text) => {
    if (!text) return NaN;
    return parseFloat(String(text).replace(/[^\d.-]+/g, ""));
  };

  function updateAtcPrice(discounted, original) {
    if (isNaN(discounted)) return;

    document.querySelectorAll(".add_to_cart_holder .add_to_cart_holder__price .price").forEach((priceWrapper) => {
      const discountedAmountElement = priceWrapper.querySelector("ins .amount") || priceWrapper.querySelector(".amount.discounted");
      const compareAmountElement = priceWrapper.querySelector("del .amount");
      const comparePriceElement = compareAmountElement ? compareAmountElement.closest("del") : null;

      if (discountedAmountElement && discounted < original) {
        discountedAmountElement.textContent = formatMoney(discounted);
      }

      if (!comparePriceElement) return;

      const hasDiscount = !isNaN(original) && original > discounted && original > 0;
      const compareBreak = comparePriceElement.nextElementSibling;

      if (hasDiscount) {
        compareAmountElement.textContent = formatMoney(original);
        comparePriceElement.style.removeProperty("display");
        if (compareBreak && compareBreak.tagName === "BR") {
          compareBreak.style.removeProperty("display");
        }
      } else {
        comparePriceElement.style.display = "none";
        if (compareBreak && compareBreak.tagName === "BR") {
          compareBreak.style.display = "none";
        }
      }

      if (discountedAmountElement && discounted < original) {
        discountedAmountElement.classList.toggle("discounted", hasDiscount);
      }
    });
  }

  function syncBundleSaveAtcPrice(contextNode) {
    const bundleWrapper =
      contextNode?.closest?.(".bundle-wrapper, .custom_bundle-wrapper") ||
      document.querySelector(".bundle-wrapper, .custom_bundle-wrapper");

    if (!bundleWrapper) return;

    const checkedInput = bundleWrapper.querySelector(':scope > input[type="radio"][name="quantity"]:checked');
    const activeLabel = checkedInput?.nextElementSibling;
    const activeBundleItem = activeLabel?.querySelector(".bundle-item_wrapper") || activeLabel;

    if (!activeBundleItem) return;

    const discountedText = activeBundleItem.querySelector(".amount.discounted")?.textContent;
    const originalText = activeBundleItem.querySelector(".original_price .amount")?.textContent;

    const discounted = parseMoney(discountedText);
    const original = parseMoney(originalText);
    updateAtcPrice(discounted, original);
  }

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!target) return;

    if (
      target.matches('.bundle-wrapper > input[type="radio"][name="quantity"], .custom_bundle-wrapper > input[type="radio"][name="quantity"]') ||
      target.matches(".bundle-wrapper .quantity-break__variant-select, .custom_bundle-wrapper .quantity-break__variant-select") ||
      target.matches('.bundle-wrapper [name="quantity"], .custom_bundle-wrapper [name="quantity"]')
    ) {
      setTimeout(function () {
        syncBundleSaveAtcPrice(target);
      }, 0);
    }
  });

  setTimeout(function () {
    syncBundleSaveAtcPrice(document);
  }, 120);
});
